import Container from 'components/Container';
import Footer from 'components/Footer';
import * as React from 'react';
import cx from 'classnames';
import './styles/UnauthenticatedView.scss';

export type Props = {
  title?: string | JSX.Element;
  className?: string;
  children: React.ReactNode;
};

export default function UnauthenticatedView({ title, className, children }: Props) {
  return (
    <>
      <main className={cx('UnauthenticatedView', className)}>
        <Container className="UnauthenticatedView-container">
          {title && <h1 className="UnauthenticatedView-title">{title}</h1>}
          {children}
        </Container>
      </main>
      <Footer />
    </>
  );
}
